export enum ExportType {
    Excel = 0,
    CSV = 1,
    RawData = 2
}
